export default __webpack_public_path__ + "static/media/password_background.edc2e406.jpg";